module.exports = __webpack_public_path__ + "img/375.2251ef50.jpg";